'use strict';

export default class NotificationSoundManager {
  constructor() {
    if (NotificationSoundManager.instance) return NotificationSoundManager.instance;
    NotificationSoundManager.instance = this;

    this.isPlaying = false;
    this.incomingSmsBuffer = { context: null, sourceNode: null };

    return NotificationSoundManager.instance;
  }

  install(Vue) {
    NotificationSoundManager.instance.playNotificationSound = this._playNotificationSound;

    Vue.prototype.$notificationSoundManager = NotificationSoundManager.instance;
  }

  _playNotificationSound(notificationSound, buffer, loop = false) {
    if (!notificationSound.buffer) return;

    if (buffer.context && buffer.sourceNode) {
      buffer.sourceNode.stop(0);
    }

    buffer.context = NotificationSoundManager.getAudioContext();
    buffer.sourceNode = buffer.context.createBufferSource();
    buffer.sourceNode.connect(buffer.context.destination);
    buffer.sourceNode.buffer = notificationSound.buffer;
    buffer.sourceNode.loop = loop;
    buffer.sourceNode.start(0);
  }

  static getAudioContext() {
    const audioContext = new AudioContext();
    const sampleSize = 1024;
    const javascriptNode = audioContext.createScriptProcessor(sampleSize, 1, 1);
    javascriptNode.connect(audioContext.destination);
    return audioContext;
  }
}
